module.exports = __webpack_public_path__ + "assets/certificate_pdf/CCNA_200-125_CISCO_429011205263JODH_20170615.db65c263.pdf";